class RespondTo extends React.Component {
  render () {
    return (
      <li className="section__item">
        <h3 className="section__item-title" id="respond-to">
          Respond To
          <span className="section__item-docs">
            Documentation: <a href="docs/scss#mixins-mixin-respond-to" target="_blank">SCSS</a>
          </span>
        </h3>
        <div className="section__demo">
         <Collapser>
            <div className="demo">
              <h4 className="demo__title">Responsive Color change</h4>
              <div className="demo__code">
                <CodeBlock lang="html">
                {`
<p className="respond-to-demo">
  Watch the color change as you resize the screen
</p>
                `}
                </CodeBlock>
                <CodeBlock lang="scss">
                {`
.respond-to-demo {
  background: $lipstick;
  height: 250px;

  @include respond-to(large-desktop) {
    background: $apricot;
  }

  @include respond-to(tablet-landscape-desktop) {
    background: $weird-green;
  }

  @include respond-to(tablet-portrait) {
    background: $azure;
  }

  @include respond-to(phone) {
    background: $pink;
  }
}
                `}
                </CodeBlock>
              </div>
              <div className="demo__output">
                <Output>
                  <p className="respond-to-demo">
                    Watch the color change as you resize the screen
                  </p>
                </Output>
              </div>
            </div>
            <div className="demo">
              <h4 className="demo__title">Pixel Density Color change</h4>
              <div className="demo__code">
                <CodeBlock lang="html">
                {`
<p className="respond-to-demo--density">
  WThis window is '$wrid-green' on retina and '$azure' on non retina
</p>
                `}
                </CodeBlock>
                <CodeBlock lang="scss">
                {`
.respond-to-demo--density {
  height: 250px;

  @include respond-to(non-retina) {
    background: $azure;
  }

  @include respond-to(retina) {
    background: $weird-green;
  }
}
                `}
                </CodeBlock>
              </div>
              <div className="demo__output">
                <Output>
                  <p className="respond-to-demo--density">
                    This window is '$wrid-green' on retina and '$azure' on non retina
                  </p>
                </Output>
              </div>
            </div>
          </Collapser>
        </div>
      </li>
    );
  }
};
